import React, { useEffect, useState } from 'react';
import * as Tone from 'tone';

const ArrangerKeyboard = () => {
  const [instrument, setInstrument] = useState('piano');
  const [synth, setSynth] = useState(null);

  const octaves = [3, 4, 5];
  const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

  const instruments = {
    piano: new Tone.PolySynth(Tone.Synth).toDestination(),
    strings: new Tone.PolySynth(Tone.AMSynth).toDestination(),
    sitar: new Tone.PolySynth(Tone.MonoSynth).toDestination(),
  };

  useEffect(() => {
    setSynth(instruments[instrument]);
  }, [instrument]);

  const playNote = (note) => {
    if (synth) {
      synth.triggerAttackRelease(note, '8n');
    }
  };

  const getKeyStyle = (note) => {
    const isSharp = note.includes('#');
    return {
      backgroundColor: isSharp ? '#333' : 'white',
      color: isSharp ? 'white' : 'black',
      width: isSharp ? '40px' : '60px',
      height: isSharp ? '140px' : '200px',
      marginLeft: isSharp ? '-20px' : '0',
      marginRight: isSharp ? '-20px' : '0',
      zIndex: isSharp ? 2 : 1,
      position: 'relative',
      border: '1px solid black',
      display: 'inline-block',
      textAlign: 'center',
      lineHeight: isSharp ? '140px' : '200px',
      cursor: 'pointer',
      userSelect: 'none',
    };
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px', fontFamily: 'sans-serif' }}>
      <h2>🎹 Arranger Keyboard</h2>
      <div style={{ marginBottom: '20px' }}>
        <label>Choose Instrument: </label>
        <select value={instrument} onChange={(e) => setInstrument(e.target.value)}>
          <option value="piano">Piano</option>
          <option value="strings">Strings</option>
          <option value="sitar">Sitar</option>
        </select>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', overflowX: 'auto' }}>
        {octaves.map((oct) => (
          <div key={oct} style={{ position: 'relative', display: 'flex' }}>
            {notes.map((note) => {
              const fullNote = note.replace('#', '♯') + oct;
              const midiNote = note + oct;
              return (
                <div
                  key={fullNote}
                  style={getKeyStyle(note)}
                  onClick={() => playNote(midiNote)}
                >
                  {note}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArrangerKeyboard;
